module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Regular.27705d9.ttf";